import {
  DesktopOrTablet,
  MediaContextProvider,
  Mobile
} from '@/components/atoms/media'
import type { FC } from 'react'
import { useWishlist } from '@/providers/wishlistProvider'
import DesktopToolbarRedesign from '@/components/organisms/toolbar/desktop/desktopToolbarRedesign'
import MobileToolbarNew from '@/components/organisms/toolbar/mobile/mobileToolbarNew'
import { HeaderNotice } from '@/network/graphql.g'

type ToolbarRedesignProps = {
  onDrawerClick?: () => void
  showHeaderPromo?: boolean
  headerNotice?: HeaderNotice
  isSearchbarOpen?: boolean
}

export type ToolbarProps = {
  onDrawerClick?: () => void
  showHeaderPromo: boolean
  isSticky?: boolean
  headerNotice?: HeaderNotice
  isHeaderNoticeEnabled?: boolean
  isSearchbarOpen?: boolean
}

export type TabletOrMobileToolbarProps = {
  wishlistProductCount: number
  showHeaderPromo: boolean
}

const ToolbarRedesign: FC<ToolbarRedesignProps> = ({
  onDrawerClick,
  showHeaderPromo,
  headerNotice,
  isSearchbarOpen
}) => {
  const { wishlistProductCount } = useWishlist()

  return (
    <MediaContextProvider>
      <DesktopOrTablet>
        <DesktopToolbarRedesign
          wishlistProductCount={wishlistProductCount}
          onDrawerClick={onDrawerClick}
        />
      </DesktopOrTablet>
      <Mobile>
        <MobileToolbarNew
          onDrawerClick={onDrawerClick}
          wishlistProductCount={wishlistProductCount}
          showHeaderPromo={showHeaderPromo}
          headerNotice={headerNotice}
          isSearchbarOpen={isSearchbarOpen}
        />
      </Mobile>
    </MediaContextProvider>
  )
}

export default ToolbarRedesign
